import { tss } from 'tss-react/mui';
import { colors } from '../../../../../../Utilities/LenoxColors';

export const useTYWallCarriersLeadDemographicsItemStyles = tss.create(
  ({ theme: { breakpoints } }) => ({
    container: {
      margin: '1rem',
      marginTop: '5px',
      minHeight: '370px',
      display: 'flex',
      flexDirection: 'column'
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%'
    },
    blockTitle: {
      fontSize: '1.25rem',
      textAlign: 'center',
      padding: '.5rem',
      backgroundColor: colors.lenoxDark2,
      color: colors.lenoxLight1,
      borderTopLeftRadius: '6px',
      borderTopRightRadius: '6px'
    },
    chartContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexGrow: 2,
      alignItems: 'center'
    },
    pieAndTableWrapper: {
      display: 'flex',
      flexDirection: 'row',
      margin: '1rem 0',
      justifyContent: 'end',
      paddingRight: '30px',
      [breakpoints.down('md')]: {
        width: '100%',
        paddingRight: '0',
        flexDirection: 'column',
        alignItems: 'center'
      }
    },
    table: {
      width: '40%',
      marginLeft: '4rem',
      [breakpoints.down('md')]: {
        width: '100%',
        marginLeft: 'auto'
      }
    }
  })
);
